const unitDropdownOptionsMixin = {
    data: () => ({
        $uomOptions: [
            {
                value: "LITRE",
                label: "L"
            },
            {
                value: "MILLILITRE",
                label: "mL"
            },
            {
                value: "KILOGRAM",
                label: "KG"
            },
            {
                value: "GRAM",
                label: "g"
            },
        ],
        $unitTypeOptions: [
            "Bottle",
            "Jar",
            "Piece",
            "Bag",
            "Can",
            "Tin"
        ],
    })
};
export default unitDropdownOptionsMixin;